<template>
  <ElTable :data="purchases">
    <ElTableColumn
      width="200"
      prop="sku"
      :label="$t('APP.TRANSACTIONS.PURCHASES_SKU')"
    >
      <template slot-scope="{ row: { sku } }">
        <code>{{ sku }}</code>
      </template>
    </ElTableColumn>

    <ElTableColumn
      prop="date"
      min-width="130"
      :label="$t('APP.TRANSACTIONS.PURCHASES_Time')"
    >
      <template slot-scope="{ row: { date } }">
        {{ translateDate(date) }}
      </template>
    </ElTableColumn>

    <ElTableColumn
      prop="amount"
      min-width="100"
      :label="$t('APP.TRANSACTIONS.PURCHASES_AMOUNT')"
    >
      <template slot-scope="{ row: { amount } }">
        {{ currencyFormat(amount) }} {{ $t('RIALS') }}
      </template>
    </ElTableColumn>

    <ElTableColumn
      prop="user"
      min-width="150"
      :label="$t('APP.TRANSACTIONS.PURCHASES_USER')"
    >
      <template slot-scope="{ row: { user } }">
        <span dir="ltr">
          {{ user }}
        </span>
      </template>
    </ElTableColumn>

    <ElTableColumn
      prop="subscription_token"
      min-width="160"
      :label="$t('APP.TRANSACTIONS.PURCHASES_SUBSCRIPTION_TOKEN')"
    >
      <template slot-scope="{ row: { subscription_token } }">
        <span class="text-latin">{{ subscription_token }}</span>
      </template>
    </ElTableColumn>

    <ElTableColumn
      prop="token"
      min-width="160"
      :label="$t('APP.TRANSACTIONS.PURCHASES_RENEWAL_TOKEN')"
    >
      <template slot-scope="{ row: { renewal_token } }">
        <span class="text-latin">{{ renewal_token }}</span>
      </template>
    </ElTableColumn>

    <ElTableColumn
      prop="payload"
      min-width="150"
      :label="$t('APP.TRANSACTIONS.DEVELOPER_PAYLOAD')"
    >
      <template slot-scope="{ row: { developer_payload } }">
        <span class="text-latin">{{ developer_payload }}</span>
      </template>
    </ElTableColumn>

    <ElTableColumn
      prop="refund_date"
      width="80"
      align="center"
      :label="$t('APP.TRANSACTIONS.PURCHASES.REFUNDS')"
    >
      <template v-if="refund_date" v-scope="{ row: { refund_date } }">
        <ElTooltip
          :content="
            $t('APP.TRANSACTIONS.PURCHASES.REFUNDS.DATE', {
              date: translateDate(refund_date),
            })
          "
          placement="top"
        >
          <i class="refund-icon el-icon-success" />
        </ElTooltip>
      </template>
    </ElTableColumn>
  </ElTable>
</template>

<script>
import { dateFormat } from '@/utils/date';
import { format as currencyFormat } from '@/utils/number';
import lang from '@/mixins/lang';

export default {
  name: 'TransactionsSubPurchasesTable',

  mixins: [lang],

  props: {
    purchases: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    currencyFormat,
    translateDate(date) {
      let toFormat = 'DD/MM/YYYY HH:mm';

      if (this.lang === 'fa') {
        toFormat = 'jYYYY/jMM/jDD HH:mm';
      }

      return dateFormat()(toFormat)(date);
    },
  },
};
</script>

<style lang="scss">
.refund-icon {
  color: $lb-color-alert;
  font-size: $lb-side-nav-font-size * 1.3;
}
</style>
